import axiosInstance from "../axiosInstance";
import { currentBaseURL, sendEmailVerificationLinkEndpoint } from "../endpoints";

const sendEmailVerificationLink = async (email) => {
  try {
    const response = await axiosInstance.post(`${currentBaseURL}/${sendEmailVerificationLinkEndpoint}`, {
      email,
    });
    return response;
  } catch (e) {
    console.log(e);
    throw e;
  }
};

export { sendEmailVerificationLink };
